import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const zxcvbn = require('zxcvbn');

@Component({
  selector: 'rav-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnChanges {
  @Input() pwValue: string;
  @Input() form: FormGroup;
  passwordStrength = 0;
  insecureWords = [
    'raven',
    'document',
    'scanner',
    'raven scanner',
    'document scanner',
    'raven document',
    'doc',
    'docs',
    'documents'
  ];

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    const userInputs = [this.form.value['first_name'], this.form.value['last_name'], this.form.value['email']];
    const pw = zxcvbn(this.pwValue, this.insecureWords.concat(userInputs));
    this.passwordStrength = pw.score;
  }
}
